import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';

@Component({
    selector: 'app-address-data',
    templateUrl: './address-data.component.html',
    styleUrls: ['./address-data.component.scss']
})
export class AddressDataComponent implements OnInit {
    @Input() formGroupName: string = 'addressData';

    constructor(private rootForm: FormGroupDirective) {}

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: FormGroup = new FormGroup({});

    ngOnInit() {
        this.form = this.rootForm.control.get(this.formGroupName) as FormGroup;
    }
}
